import { Component, inject } from '@angular/core';
import { LocationTypePerActivityService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LocationTypePerActivityCreateDto,
  LocationTypePerActivityDto,
  LocationTypePerActivityExcelDownloadDto,
  LocationTypePerActivityUpdateDto,
} from '../proxy/controlling/dtos/location-type-per-activity';
import { LOCATIONTYPEPERACTIVITY_CONFIG, LOCATIONTYPEPERACTIVITY_FIELDS } from './location-type-per-activity.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-location-type-per-activity',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LocationTypePerActivityService, ConfirmationService],
  templateUrl: './location-type-per-activity.html',
  styleUrl: './location-type-per-activity.scss',
})
export class LocationTypePerActivity extends BaseHierarchicalCrudComponent<
  LocationTypePerActivityDto,
  LocationTypePerActivityCreateDto,
  LocationTypePerActivityUpdateDto,
  LocationTypePerActivityExcelDownloadDto
> {
  service = inject(LocationTypePerActivityService);
  config = LOCATIONTYPEPERACTIVITY_CONFIG;
  fields = LOCATIONTYPEPERACTIVITY_FIELDS;

  protected prepareUpdateDto(data: any, selected: LocationTypePerActivityDto): LocationTypePerActivityUpdateDto {
    return {
      patrimonyActivityParameterId: data.patrimonyActivityParameterId,
      locationTypeId: data.locationTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LocationTypePerActivity';
  }
}
